import React from "react";
import style from "./Contacts.module.css";

const Contacts = () => {
  return <div className={style.Contacts}>Contacts</div>;
};

export default Contacts;
